import createIcon from '../../createIcon';

/**
 * @component @name Attribution
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgOC41QzExLjA5IDguNSA5LjI1IDguOTYgOS4yNSA5Ljg4VjE0LjVIMTAuNzVWMTlIMTMuMjVWMTQuNUgxNC43NVY5Ljg4QzE0Ljc1IDguOTcgMTIuOTEgOC41IDEyIDguNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMiAyQzYuNDcgMiAyIDYuNDcgMiAxMkMyIDE3LjUzIDYuNDcgMjIgMTIgMjJDMTcuNTMgMjIgMjIgMTcuNTIgMjIgMTJDMjIgNi40OCAxNy41MiAyIDEyIDJaTTEyIDIwQzcuNTggMjAgNCAxNi40MiA0IDEyQzQgNy41OCA3LjU4IDQgMTIgNEMxNi40MiA0IDIwIDcuNTggMjAgMTJDMjAgMTYuNDIgMTYuNDIgMjAgMTIgMjBaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTIgOEMxMi44Mjg0IDggMTMuNSA3LjMyODQzIDEzLjUgNi41QzEzLjUgNS42NzE1NyAxMi44Mjg0IDUgMTIgNUMxMS4xNzE2IDUgMTAuNSA1LjY3MTU3IDEwLjUgNi41QzEwLjUgNy4zMjg0MyAxMS4xNzE2IDggMTIgOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Attribution = createIcon('Attribution', [
  [
    'path',
    {
      d: 'M12 8.5C11.09 8.5 9.25 8.96 9.25 9.88V14.5H10.75V19H13.25V14.5H14.75V9.88C14.75 8.97 12.91 8.5 12 8.5Z',
      key: '1puxwc',
    },
  ],
  [
    'path',
    {
      d: 'M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z',
      key: 'tm4duj',
    },
  ],
  [
    'path',
    {
      d: 'M12 8C12.8284 8 13.5 7.32843 13.5 6.5C13.5 5.67157 12.8284 5 12 5C11.1716 5 10.5 5.67157 10.5 6.5C10.5 7.32843 11.1716 8 12 8Z',
      key: '1jf86s',
    },
  ],
]);

export default Attribution;
